import { RECENTLY_VIEWED_PRODUCTS_KEY } from "@constants/storageKeys"
import {
  selectAutomaticDiscountAllocations,
  selectAutomaticDiscountApplied,
  selectCartQuantity,
  selectCheckoutLink,
  selectCouponCodeApplied,
} from "@redux/selectors"
import { Dispatch, RootState } from "@redux/store"
import { getLocalStorage } from "@utils/storage"
import { connect } from "react-redux"

import Cart from "../index"

const mapState = (state: RootState) => ({
  automaticDiscountAllocations: selectAutomaticDiscountAllocations(state),
  automaticDiscountApplied: selectAutomaticDiscountApplied(state),
  automaticDiscounts: state.discounts.automaticDiscounts,
  cartCount: selectCartQuantity(state),
  checkoutLink: selectCheckoutLink(state),
  couponCodeApplied: selectCouponCodeApplied(state),
  customerLocation: state.customer.customerLocation,
  discountedProductsData: state.discounts.discountedProductsData,
  discountedProductsInventoryData:
    state.discounts.discountedProductsInventoryData,
  items: state.checkout.localCheckout?.items || [],
  recentItems: getLocalStorage(RECENTLY_VIEWED_PRODUCTS_KEY) || [],
  showPromoToast: state.checkout.showPromoToast,
  subtotal: state.checkout.localCheckout?.subtotal || "",
  total: state.checkout.localCheckout?.total || "",
})

const mapDispatch = (dispatch: Dispatch) => ({
  addToCart: dispatch.checkout.addToCart,
  fetchDiscountInventoryForProduct:
    dispatch.discounts.fetchDiscountInventoryForProduct,
  onRemoveDiscount: () => {
    dispatch.checkout.updateDiscount(undefined)
  },
  onUpdateCartItem: dispatch.checkout.updateCart,
  onUpdateDiscount: dispatch.checkout.updateDiscount,
})

export default connect(mapState, mapDispatch)(Cart)
